function CloseIFrame (props) {
  console.log("IFrame closed");
        window.parent.location.reload();
        return(
        null
        )
    }

export default CloseIFrame